class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
        this.onCartChange = this.onCartChange.bind(this);
    }

    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.progressBarElement = this.querySelector('[role="progressbar"]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
        this.threshold = Number(window.free_shipping_price);

        if (!this.progressBar || !this.progressBarElement || !this.messageElement || !this.progressMeter || !Number.isFinite(this.threshold) || this.threshold <= 0) {
            this.hidden = true;
            return;
        }

        this.addEventListener('change', this.onCartChange);

        this.initialize();
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.onCartChange);
        window.clearTimeout(this.updateTimer);
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        });
    }

    onCartChange() {
        this.initialize();
    }

    calculateProgress(cart) {
        const cartTotalPrice = Number(cart.total_price) / 100;
        const freeShipBar = Math.min(100, Math.max(0, (cartTotalPrice / this.threshold) * 100));

        const text = this.getText(cartTotalPrice);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartTotalPrice) {
        const shippingText = window.free_shipping_text || {};
        let text;

        if (cartTotalPrice === 0) {
            this.progressBar.classList.add('progress-hidden');
            text = '<span>' + shippingText.free_shipping_message + ' ' + Shopify.formatMoney(this.threshold * 100, window.money_format) + '!</span>';
        } else if (cartTotalPrice >= this.threshold) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text = shippingText.free_shipping_message_1;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingPrice = Math.max(0, this.threshold - cartTotalPrice);
            text = '<span>' + shippingText.free_shipping_message_2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' + shippingText.free_shipping_message_3 + ' </span><span class="text">' + shippingText.free_shipping_message_4 + '</span>';
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('none', 'progress-30', 'progress-60', 'progress-100', 'progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        window.clearTimeout(this.updateTimer);
        this.updateTimer = window.setTimeout(() => {
            this.resetProgressClass(classLabel);

            this.progressMeter.style.width = `${freeShipBar}%`;
            this.progressBarElement.setAttribute('aria-valuenow', String(Math.round(freeShipBar)));
            this.progressBarElement.setAttribute('aria-valuetext', this.messageElement.textContent || `${Math.round(freeShipBar)}%`);
            if (this.textEnabled) {
                const percentText = this.progressMeter.querySelector('.text');
                if (percentText) {
                    percentText.textContent = `${Math.round(freeShipBar)}%`;
                }
            }

            this.messageElement.innerHTML = text;
            this.progressBarElement.setAttribute('aria-valuetext', this.messageElement.textContent.trim());

            if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    if (!customElements.get('free-shipping-component')) {
        customElements.define('free-shipping-component', FreeShippingMeter);
    }
})
